/** "Nome — N4 — Cargo" ou "Nome — Sem nível de aprovação": nome, nível e cargo sempre separados por " — ". */
export const rotuloUsuarioComNivel = (u: { nome: string; nivel?: number | null; cargo?: string | null }): string => {
  const nome = (u.nome ?? '').trim();
  const cargo = (u.cargo ?? '').trim();
  if (!u.nivel) return `${nome} — Sem nível de aprovação`;
  return cargo ? `${nome} — N${u.nivel} — ${cargo}` : `${nome} — N${u.nivel}`;
};
